import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import teacherReducer from './slices/teacherSlice'
import batchReducer from './slices/batchSlice'
import lectureReducer from './slices/lectureSlice'
import themeReducer from './slices/themeSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    teacher: teacherReducer,
    batch: batchReducer,
    lecture: lectureReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

// Export store types for use in components
export const getState = () => store.getState()
export const dispatch = store.dispatch